import { createFileRoute } from '@tanstack/react-router';
import { DeviceModelsPage } from '@/features/device-models/components/DeviceModelsPage';

export const Route = createFileRoute('/_app/device-models/')({
  component: DeviceModelsPage,
});
